// track/components/ClientsView.tsx
import React from 'react';
import { Plus } from 'lucide-react';
import { Client } from '../types';

interface ClientsViewProps {
  clients: Client[];
  canWrite: boolean;
  onAddClient: () => void;
}

const ClientsView: React.FC<ClientsViewProps> = ({ clients, canWrite, onAddClient }) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Clients</h2>
        {canWrite && (
          <button
            onClick={onAddClient}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Client
          </button>
        )}
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Address</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {clients.map(client => (
              <tr key={client.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{client.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{client.email || '-'}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{client.phone || '-'}</td>
                <td className="px-6 py-4 text-sm text-gray-900">{client.address || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {clients.length === 0 && (
          <div className="text-center py-8">
            <p className="text-gray-500">No clients found. {canWrite ? 'Add your first client to get started.' : ''}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientsView;